import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from "../../../api/axios";

import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

import AddIcon from "@mui/icons-material/Add";
import ContentCopy from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

import { DataGridPro, LicenseInfo } from "@mui/x-data-grid-pro";

import "./price_table.css";

import PriceChangeDlg from "./PriceChangeDlg";
import {
  Typography,
  Grid,
  Select,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
} from "@mui/material";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import Close from "@mui/icons-material/Close";
import { url } from "../../../configlink";
import { useSelector } from "react-redux";

export default function PriceTable() {
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  const [categoryData, setCategoryData] = useState([]);
  const [itemData, setItemData] = useState([]);

  const [category, setCategory] = useState(0);
  const [item, setItem] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogName, setOpenDialog] = useState(null);

  // const [userId, setUserId] = useState(767);

  let loc = useLocation();

  const [selectedUserId, setSelectedUserId] = useState();

  const selectedUserId2 = useRef();

  LicenseInfo.setLicenseKey(
    "c8d4b234c7655de781a1569d518a0f4dTz0xMTAwOTksRT0xNzc0MTM3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
  );

  useEffect(() => {
    let uId = loc.search.split("=")[1];
    console.log(uId);

    setSelectedUserId(uId);
    // console.log("call price dialog");
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [search_value, setSearchValue] = useState("");
  let [editRowId, setEditRowId] = useState(null);

  const openDialog = () => {
    //alert('OpenDialog =======>    ' + userId);
    /*alert('Selected Userid====' + userId);
    switch (openDialogName) {
      case 1:
        setOpenDialog(openDialogName);
        handleClose();
    }*/
  };

  // console.log(editRowId);

  const closeDialog = () => {
    setOpenDialog(null);
  };

  useEffect(() => {
    getItems();
    // alert(selectedUserId);
  }, [selectedUserId, category, item]);

  useEffect(() => {
    getCategoryDrpDown();
    getItemDrpDown();
  }, []);

  const getCategoryDrpDown = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_category_for_pricepage_dropbox`, {
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      setCategoryData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getItemDrpDown = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_items_for_pricepage_dropbox`,
        {
          params: { orderTypeId: category },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );

      setItemData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getItems = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_price_items_by_users`,
        {
          params: { userId: selectedUserId, category: category, item: item },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      setRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const handleItemChange = (event) => {
    setItem(event.target.value);
  };

  let [editDialog, setEditDialog] = useState(false);

  const handleEditClick = (id) => {
    // setEditRowId(id);
    // setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    let val = rows.filter((x) => x.ItemDetailId === id)[0].Price;
    setEditDialog({ bool: true, rowId: id, price: val });
  };

  // console.log(editRowId);
  console.log(rowModesModel);

  const handleSaveClick = (id) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  function updatePrice() {
    console.log(editDialog);
    let id2 = editDialog.rowId;
    let value = editDialog.price;

    fetch(`${url}/api/admin/updatePrice?itemDetailId=${id2}`, {
      method: "PUT",
      headers: {
		"Content-Type": "application/json",
		'acgt-admin': adminUser
      },
      body: JSON.stringify({ value: value }),
      credentials: 'include'
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "success") {
          alert("updated");
          setEditDialog(false);
          getItems();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleRemoveAllPrice = (selectedUserId) => {
    fetch(
      `${url}/api/admin/price_admin_delete_all_price?userId=${selectedUserId}`,
      {
        method: "PUT",
        headers: {
			"Content-Type": "application/json",
			'acgt-admin': adminUser
        },
        credentials: 'include',
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "success") {
          alert("updated");
          getItems();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDeleteClick = (id) => {
    console.log("selected id===" + id);
    fetch(`${url}/api/admin/price_admin_delete_price?id=${id}`, {
      method: "PUT",
      headers: {
		"Content-Type": "application/json",
		'acgt-admin': adminUser
      },
      credentials: 'include'
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "success") {
          alert("updated");
          setEditDialog(false);
          getItems();
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleCopyPrice = (id) => {
    // setOpenDialog("price_change_dlg");
    // openDialog();

    const url = `/pricecopy?id=${id}`;
    const width = 1000;
    const height = 900;

    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    window.open(
      url,
      "_blank",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  };

  function addPriceRow() {
    alert(
      `call api for adding itemData.value: ${addItemValue}   selecteduserIdL ${selectedUserId}`
    );

    console.log(
      "selected id===" + selectedUserId + "    addItem===" + addItemValue
    );
    fetch(
      `${url}/api/admin/price_admin_add_item_price?userId=${selectedUserId}&itemId=${addItemValue}`,
      {
        method: "PUT",
        headers: {
			"Content-Type": "application/json",
			'acgt-admin': adminUser
        },
        credentials: 'include'
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.message === "success") {
          alert("updated");
          setEditDialog(false);
          getItems();
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setIsAddPriceOpened(false);
  }

  const columns = [
    { field: "id", headerName: "ID", type: "number", hide: true },

    {
      field: "CategoryName",
      headerName: "Category",
      type: "string",
      width: 350,
      editable: false,
    },
    {
      field: "Item",
      headerName: "Item",
      type: "string",
      width: 300,
      editable: false,
    },
    {
      field: "Activated",
      headerName: "Activated",
      type: "boolean",
      width: 100,
      editable: false,
    },
    {
      field: "ActivatedDate",
      headerName: "ActivatedDate",
      type: "string",
      width: 200,
      editable: false,
    },
    {
      field: "DeActivatedDate",
      headerName: "DeActivatedDate",
      type: "string",
      width: 200,
      editable: false,
    },
    {
      field: "Price",
      headerName: "Price",
      type: "string",
      width: 100,
      editable: true,
    },
    {
      field: "OrderItemId",
      headerName: "OrderItemId",
      type: "number",
      hide: true,
    },
    {
      field: "ItemDetailId",
      headerName: "ItemDetailId",
      type: "number",
      hide: true,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      // getActions: ({ id }) => {
      //   const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

      //   if (isInEditMode) {
      //     return [
      //       <GridActionsCellItem
      //         icon={<AddIcon />}
      //         label="Save"
      //         sx={{
      //           color: "primary.main",
      //         }}
      //         key={id}
      //         onClick={() => handleSaveClick(id)}
      //       />,
      //       <GridActionsCellItem
      //         icon={<CancelIcon />}
      //         label="Cancel"
      //         key={id}
      //         className="textPrimary"
      //         onClick={() => handleCancelClick(id)}
      //         color="inherit"
      //       />,
      //     ];
      //   }

      //   return [
      //     <GridActionsCellItem
      //       icon={<EditIcon />}
      //       label="Edit"
      //       className="textPrimary"
      //       key={id}
      //       onClick={() => handleEditClick(id)}
      //       color="inherit"
      //     />,
      //     <GridActionsCellItem
      //       icon={<DeleteIcon />}
      //       label="Delete"
      //       key={id}
      //       onClick={() => handleDeleteClick(id)}
      //       color="inherit"
      //     />,
      //   ];
      // },
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            key={id}
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            key={id}
            onClick={() => handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  function checkMe(x) {
    console.log(x);
    return false;
  }

  const [isOpened, setIsOpened] = useState(false);
  const [isAddPriceOpened, setIsAddPriceOpened] = useState(false);
  let [addItemValue, setAddItemValue] = useState(null);

  return (
    <div>
      {/* <PriceChangeDlg
        open={openDialogName === "price_change_dlg"}
        onClose={closeDialog}
        selectedUserId3={selectedUserId2.current}
      /> */}

      {editDialog.bool === true && (
        <div>
          <div className="w-full h-full fixed top-0 left-0 bg-black opacity-60 z-10"></div>
          <div className="flex flex-col gap-[20px] items-center px-4 py-10 w-[450px] rounded-md  fixed top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] bg-white z-20">
            <h1 className="text-[20px] font-bold text-[var(--color-primary-purple)]">
              Set Price
            </h1>
            <button
              onClick={() => setEditDialog(false)}
              className="absolute top-2 right-3 bg-red-500 text-white px-[5px]"
            >
              X
            </button>
            <input
              className="border-1 border-black px-2 py-1 text-[18px] text-center"
              value={editDialog.price}
              onChange={(e) =>
                setEditDialog({ ...editDialog, price: e.target.value })
              }
            />
            <button
              className="bg-[var(--color-primary-purple)] text-white px-2 py-1"
              onClick={() => updatePrice()}
            >
              Update
            </button>
          </div>
        </div>
      )}

      <div>
        <div className="App2">
          <div className="header2">
            <h5 className="header-title2">Change the price</h5>
            <div className="header-menu2">
              <Button
                sx={{ borderRadius: 10, color: "var(--color-primary-purple)" }}
                startIcon={<AddIcon />}
                onClick={() => setIsAddPriceOpened(true)}
              >
                Add
              </Button>
              <Button
                sx={{ borderRadius: 10, color: "var(--color-primary-purple)" }}
                startIcon={<ContentCopy />}
                onClick={() => handleCopyPrice(selectedUserId)}
              >
                Copy
              </Button>
              <Button
                sx={{ borderRadius: 10, color: "var(--color-primary-purple)" }}
                startIcon={<CancelIcon />}
                onClick={() => handleRemoveAllPrice(selectedUserId)}
              >
                Remove All
              </Button>
            </div>
          </div>

          <Divider component="div" />

          <div className="content">
            <Grid container gap={1}>
              <Grid item xs={12} justify="flex-start" alignItems="top">
                <Stack
                  direction="row"
                  style={{ gap: 2 }}
                  sx={{
                    justifyContent: { xs: "space-between" },
                  }}
                >
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-select-small-label">
                      Category
                    </InputLabel>
                    <Select
                      labelId="category-select-small-label"
                      id="category-select-small"
                      label="Category"
                      value={category}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem value={0}>All </MenuItem>
                      {categoryData.map((data, i) => (
                        <MenuItem
                          value={data.orderTypeId}
                          key={data.orderTypeId}
                        >
                          {data.categoryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-select-small-label">Item</InputLabel>
                    <Select
                      labelId="item-select-small-label"
                      id="item-select-small"
                      label="Item"
                      value={item}
                      options={itemData}
                      onChange={handleItemChange}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            // maxWidth: 350,
                            maxHeight: 450,
                            overflow: "auto",
                          },
                        },
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left", // Ensure the dropdown opens aligned to the left of the Select box
                        },
                      }}
                    >
                      <MenuItem value={0}>All </MenuItem>
                      {itemData.map((data, i) => (
                        <MenuItem value={data.value} key={data.value}>
                          {data.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
              </Grid>

              {isAddPriceOpened && (
                <div className="bg-[#eee] relative py-3 my-[10px] flex flex-col gap-[20px] w-[70%] px-[30px]">
                  <h5 className="header-title2" style={{ textAlign: "left" }}>
                    Add Price Item
                  </h5>

                  <button
                    onClick={() => setIsAddPriceOpened(false)}
                    className="absolute top-2 right-3 bg-red-500 text-white px-[5px]"
                  >
                    X
                  </button>

                  <div className="flex gap-[50px] w-full">
                    <FormControl size="small" className="w-full">
                      <InputLabel id="demo-select-small-label">
                        Add Item
                      </InputLabel>
                      <Select
                        labelId="item-select-small-label"
                        id="item-select-small"
                        label="Add Item"
                        style={{ backgroundColor: "white" }}
                        // value={item}
                        options={itemData}
                        onChange={(e) => setAddItemValue(e.target.value)}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              // maxWidth: 350,
                              maxHeight: 450,
                              overflow: "auto",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left", // Ensure the dropdown opens aligned to the left of the Select box
                          },
                        }}
                      >
                        {itemData
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((data, i) => (
                            <MenuItem value={data.value} key={data.value}>
                              {data.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>

                    <button
                      onClick={() => addPriceRow()}
                      className="w-[120px] bg-[var(--color-primary-purple)] text-white rounded-md py-1 text-center"
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}

              <Grid item xs={12} alignItems="top">
                <DataGridPro
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        // Hide columns status and traderName, the other columns will remain visible
                        id: false,
                        OrderItemId: false,
                        ItemDetailId: false,
                      },
                    },
                  }}
                  style={{ width: "100%", height: "800px" }}
                  columnHeaderHeight={45}
                  rowHeight={40}
                  rows={rows}
                  columns={columns}
                  // isCellEditable={(params) =>
                  //   // params.row.id === editRowId &&
                  //   rowModesModel[`${params.row.id}`] &&
                  //   rowModesModel[`${params.row.id}`].mode === "edit"
                  // }
                  pageSize={100}
                  sx={{
                    "& .MuiDataGrid-columnHeaders": {
                      color: "var(--color-primary-purple)",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: 700,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
